import { createSelector } from 'reselect'

import { getOfferings } from 'partner360/features/landing/helpers/getOfferings'

import { selectLandingState } from './selectLandingState'

export const selectLandingOfferings = createSelector(
  [selectLandingState],
  ({ selectedPlanning, selectedCategory, selectedStatus, processedPlannings }) => {
    return getOfferings({
      selectedCategory,
      selectedStatus,
      selectedPlanning,
      processedPlannings,
    })
  }
)
